/* eslint-disable react-hooks/rules-of-hooks */
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import UserAvatar from 'components/UserAvatar';
import { useCurrentUserState } from 'contexts/user';
import useAuth from 'hooks/useAuth';
import Button from 'yoda-ui/components/Button';
import { ButtonType } from 'yoda-ui/components/Button/Button.types';

const NavbarContent: FC = () => {
  const { user, userLoading } = useCurrentUserState();
  const { handleLogin, handleLogout } = useAuth();
  const { t } = useTranslation();

  if (userLoading) {
    return null;
  }

  return user
    ? (
      <>
        <UserAvatar user={ user } />
        <Button onClick={ handleLogout }>{ t('actions_logout_label') }</Button>
      </>
    )
    : (
      <Button onClick={ handleLogin } buttonType={ ButtonType.primary }>{ t('actions_login_label') }</Button>
    );
};

export default NavbarContent;
